module.exports = __webpack_public_path__ + "static/img/shangbiao_04.ae22c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_04.png
// module id = ZoDR
// module chunks = 0